// extracted by mini-css-extract-plugin
module.exports = {"span":"RegisterCheckbox_span__1_Ogv","input":"RegisterCheckbox_input__21Nnh"};